import { useGLTF } from "@react-three/drei";
import { useState, useEffect } from "react";
import { GLTF } from "three-stdlib";

export function useSafeGLTF(url: string): GLTF;
export function useSafeGLTF(url: string[]): GLTF[];

/**
 * Безопасная загрузка GLTF модели с fallback на запасную модель при ошибке
 */
export function useSafeGLTF(
    url: string | string[],
    fallbackModel: string = `${process.env.PUBLIC_URL}/models/connector.glb`
): GLTF | GLTF[] {
    const [actualUrl, setActualUrl] = useState(url);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        setActualUrl(url);
        setHasError(false);
    }, [url]);

    const primaryGLTF = useGLTF(actualUrl);
    const fallbackGLTF = useGLTF(fallbackModel);

    if (!hasError) {
        try {
            if (primaryGLTF) {
                return primaryGLTF;
            }
        } catch (error) {
            console.warn(`Failed to load model: ${actualUrl}, using fallback: ${fallbackModel}`, error);
            setHasError(true);
        }
    }

    return fallbackGLTF;
}